import { System } from '../types/System';

export const system: System = {
  fetching: true,
  failed: false
};
